import { apiClient } from "./client";

// `tz` is the viewer's IANA zone. The server keeps today + the previous 6
// CALENDAR days in that zone (older rows are expired and deleted), so it has to
// know which zone "a day" means — see domain/notifications/service.py.
export async function fetchNotifications(limit = 200, tz) {
  const qs = new URLSearchParams({ limit: String(limit) });
  if (tz) qs.set("tz", tz);
  const res = await apiClient("GET", `/notifications?${qs}`);
  return res.data;
}

export async function fetchUnreadCount(tz) {
  const res = await apiClient("GET", `/notifications/unread-count${tz ? `?tz=${encodeURIComponent(tz)}` : ""}`);
  return res.data;
}

export async function markNotificationRead(id) {
  const res = await apiClient("POST", `/notifications/${id}/read`);
  return res.data;
}

export async function markAllNotificationsRead() {
  const res = await apiClient("POST", "/notifications/mark-all-read");
  return res.data;
}

// Email / phone choice per notification category — your own, or (system
// admin only) someone else's when `userId` is given.
export async function fetchNotificationPreferences(userId) {
  const qs = userId ? `?user_id=${encodeURIComponent(userId)}` : "";
  const res = await apiClient("GET", `/notifications/preferences${qs}`);
  return res.data;
}

// `preferences` = { category: { email, push } }; returns the full list again.
export async function saveNotificationPreferences(preferences, userId) {
  const res = await apiClient("PUT", "/notifications/preferences", { preferences, user_id: userId || null });
  return res.data;
}
